


































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { professionServer } from '@/api/installServer'; // 导入接口请求
import { Component, PropSync, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';

@Component({
  components: { CollapseTransition, PagingUnit, TreeUnit },
  mixins: [TableStripe],
})
export default class ProfessionIndex extends Vue {
  @PropSync('flag', Number) pageFlag!: number; // 显示哪个页面
  @PropSync('row', String) editRow!: string; // 向编辑页面传递的值
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 20; // 总共多少条数据
  page = 1; // 当前页数
  formShow = false; // 是否显示搜索表单内容
  obj: object = {}; // 搜索需要的对象
  // 表单数据对象
  formData: object = {
    spaceCode: undefined, // 岗位编码
    name: undefined, // 岗位名称
    enabled: undefined, // 岗位状态
  };
  // table 数据对象
  tableData: any[] = [];

  openAsideFlag = true; // 侧边栏是否打开

  get orgList() {
    return this.$store.state.user.orgList;
  }

  orgIdToName(id: any) {
    const a: any = this.orgList.find((s: any) => {
      return s.spaceId === id;
    });
    let d: any = '';
    if (a) {
      d = a.name;
    }
    return d;
  }

  showTree(flag: boolean) {
    this.openAsideFlag = flag;
  }

  getNodeIds(data: any) {
    this.getAllData();
  }

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 调用获取全部数据方法
    this.getAllData();
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData() {
    // 发起接口请求，获取分页数据
    professionServer
      .getPageData({
        ...this.obj,
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮触发，隐藏或显示搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */
  isShowForm() {
    this.formShow = !this.formShow;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击新增按钮触发，跳转到新增岗位页面.
   * @param1 暂无
   * @returns 暂无
   */
  addProfession() {
    this.editRow = ''; // 传递id
    this.pageFlag = 3; // 进入新增页面
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    // 搜索页和大小调回默认
    (this.obj as any).name = (this.formData as any).name;
    (this.obj as any).spaceCode = (this.formData as any).spaceCode;
    (this.obj as any).enabled = (this.formData as any).enabled;
    (this.queryDataForm as any).pageNo = 1;
    professionServer
      .getPageData({
        ...this.formData,
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.$message.success('查询成功!');
      })
      .catch((error: any) => {
        this.$message.error('查询失败，请重试!');
      });
  }

  /**
   * @desc 点击重置按钮触发，重置搜索表单内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    (this.$refs.formRef as any).resetFields();
    // 获取全部数据
    (this.queryDataForm as any).pageNo = 1;
    this.obj = {}; // 点击重置，表单数据不参与请求
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 函数描述
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  enterEdit(rowId: string) {
    this.editRow = rowId; // 给编辑页面传递需要修改的id
    this.pageFlag = 2; // 进入编辑页面
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  get setStateColor(): object {
    return (state: boolean): string => {
      if (state) {
        return 'tag-green';
      } else {
        return 'tag-red';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 状态的计算属性，如果状态是 1 则是正常 ,2 停用, 3 冻结
   * @param1 传入用户的 state 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  get setUserState(): object {
    return (state: boolean): string => {
      if (state) {
        return '正常';
      } else {
        return '停用';
      }
    };
  }

  /**
   * @desc 点击停用岗位按钮，弹出是否停用岗位
   * @param1 id：需要停用岗位的id
   * @returns 暂无
   */
  stopProfession(row: any) {
    this.$confirm(`确认要${row.enabled ? '停用岗位' : '启用岗位'}吗？`, '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        // 修改他的 enabled, 取反
        professionServer
          .editData({ id: row.id, enabled: !row.enabled })
          .then((res: any) => {
            this.getAllData();
            this.$message.success(`${row.enabled ? '停用成功!' : '启用成功!'}`);
          })
          .catch((error: any) => {
            console.log('出错了', error);
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: `已取消${row.enabled ? '停用' : '启用'}`,
        });
      });
  }

  /**
   * @todo 点击删除岗位按钮，弹出是否删除岗位
   * @param1 id：需要被删除岗位的id
   * @returns 暂无
   */
  deleteProfession(id: number) {
    this.$confirm('确认要删除该岗位吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        if (this.total % (this.queryDataForm as any).pageSize === 1 && (this.queryDataForm as any).pageNo !== 1) {
          (this.queryDataForm as any).pageNo--;
        }
        professionServer
          .deleteData({ idList: id })
          .then((res: any) => {
            this.getAllData(); // 重新渲染表格数据
            this.$message.success('删除成功!');
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
}
